import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { patientActions } from "../../core/actions";
import {
  GET_UPLOAD_HOSPITAL_PATH,
  GET_UPLOAD_PATH,
  GET_LAB_PATH,
  GET_INSURANCE_PATH,
} from "../../shared/constants";
import { Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { DialogContent } from "@mui/material";
import Card from "@material-ui/core/Card";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// import Select, { createFilter } from "react-select";
import Select from "@mui/material/Select";
import DeleteIcon from "@mui/icons-material/Delete";

import Components from "./index";
//import { modalview } from 'react-ga';
import { format } from "date-fns";
import { setValidationMode } from "@jsonforms/core";
import { helperServices } from "../../shared/helper";
import { insuranceActions } from "../../core/actions";
import { de } from "date-fns/locale";
import { set } from "lodash";

function InsuranceProcedureListing(props) {
  const [mode, setMode] = useState("new");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedType, setSelectedType] = useState();
  const dispatch = useDispatch();
  const [insuranceLists, setinsuranceLists] = useState();
  const [insuranceImages, setinsuranceImages] = useState([]);
  const [companyname, setCompanyName] = useState([]);
  const [patientInfo, setpatientInfo] = useState({
    visitId: "",
    patientId: "",
    name: "",
    age: "",
    phno: "",
    id: "",
    address: "",
    adhar: "",
    age: "",
    area: "",
    bloodgroup: "",
    city: "Arkula",
    state: "Karnataka",
    lname: "",
    mname: "",
    fname: "",
    occupation: "",
    patientcode: "",
    pincode: "",
    admsnDate: "",
    type: "OutPatient",
    fileNo: "",
    srcRef: "",
    language: "",
    education: "",
    sociostatus: "",
    tokenNumber: "",
    deskNumber: "",
    comments: "",
    status: "",
    ehrid: "",
    erpCustId: "",
    altPhno: "",
    visitDate: "",
    registeredOn: "",
    regFeesPdfUrl: "",
    emrPhono: "",
  });
  const [showClaimButton, setShowClaimButton] = useState(false);
  const [data, setData] = useState();
  const [showModal, setShowModal] = useState(false);
  const [toggleBasic, setToggleBasic] = useState(false);
  const [toggleUpload, setToggleUpload] = useState(false);
  const [togglePreauthReqt, setTogglePreauthReqt] = useState(false);
  const [togglePreauthResp, setTogglePreauthResp] = useState(false);
  const [toggleClaimreqt, setToggleClaimreqt] = useState(false);
  const [toggleClaimAppove, setToggleClaimAppove] = useState(false);
  const [deleteProcedure, setDeleteProcedure] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [claimNumber, setClaimNumber] = useState("");
  const [InvoiceGen, setInvoiceGen] = useState(false);

  // const[option, setOption] = useState([
  //     'Basic','UploadDoc','PriorRequest','PriorResponse','InvoiceGen','ClaimApproval','BillClear'
  // ]);

  const [viewInsurance, setviewInsurance] = useState(true);
  const [showWorkingButton, setShowWorkingButton] = useState(false);
  const [openInsuranceModal, setOpenInsuranceModal] = useState(
    props.addInsurance
  );
  const [selectedDateOption, setSelectedDateOption] = useState("");
  const [selectedDate, setSelectedDate] = useState();
  let resCb = "";

  useEffect(() => {
    getPatientProfile(props.patientInfo.id);
    console.log("INSURANCE SECTION", props);
    console.log("INSURANCE SECTION", props.patientInfo);
    let patientInfolocal = props.patientInfo;
    let patientId = props.patientInfo.patientId;
    let visitId = props.patientInfo.visitId;
    console.log("ALL Id:", patientId, visitId);
    const keys = Object.keys(patientInfo);
    const item = Object.keys(props.patientInfo);
    var itmData = { ...patientInfolocal };
    for (let itm of item) {
      for (let key of keys) {
        if (itm === key) {
          console.log("patientDetail : ", itmData[itm]);
          patientInfo[key] = itmData[itm];
        }
      }
    }
    // setpatientInfo(patientInfolocal);
    setSelectedDate(props.selectedDate);
  }, [props.patientInfo.visitDate]);

  useEffect(() => {
    getInsMaster();
    console.log("props in insurance procedure list : ", props);
    let patientInfolocal = props.patientInfo;
    const keys = Object.keys(patientInfo);
    const item = Object.keys(props.patientInfo);
    var itmData = { ...patientInfolocal };

    for (let itm of item) {
      for (let key of keys) {
        if (itm === key) {
          console.log("patientDetail : ", itmData[itm]);
          patientInfo[key] = itmData[itm];
        }
      }
    }
    setTimeout(() => {
      getInsuranceList();
    }, 1000);
    console.log("infoinsurance", patientInfo);
  }, [props.patientInfo.visitDate]);

  const getPatientProfile = (patId) => {
    dispatch(
      patientActions.getPatientProfile(patId, (resCb) => {
        let allvisitLists = resCb.visitList.reverse();
        if (
          allvisitLists?.length > 0 &&
          allvisitLists[0]?.visitDate === props.patientInfo?.visitDate
        ) {
          setShowWorkingButton(true);
        } else {
          setShowWorkingButton(false);
        }
      })
    );
  };
  const getInsuranceList = () => {
    console.log("props in insurance procedure list : ", patientInfo);
    dispatch(
      patientActions.getInsuranceList(patientInfo, (resCb) => {
        if (resCb) {
          console.log("Insurance listss : ", resCb.insuranceList);
        }

        if (resCb.insuranceList) {
          let insure = resCb.insuranceList.filter(
            (item) => item.markForDel == 0
          );

          const filteredInvoiceGen = insure.filter(
            (item) => item.type === "InvoiceGen"
          );
          if (filteredInvoiceGen.length > 0) {
            setInvoiceGen(true);
          }

          setinsuranceLists(insure);

          // Default: hide the claim button
          let shouldShowClaimButton = false;

          insure.forEach((insurance) => {
            if (insurance.type === "Basic") {
              setToggleBasic(true);
            }

            if (insurance.type === "pdf" || insurance.type === "png") {
              setToggleUpload(true);
            }

            if (insurance.type === "Pre Auth Request") {
              setTogglePreauthReqt(true);
            }

            if (insurance.type === "Pre Auth Response") {
              setTogglePreauthResp(true);
              setClaimNumber(insurance.claimNum);

              if (
                insurance.status === "approve" &&
                filteredInvoiceGen.length > 0
              ) {
                shouldShowClaimButton = true;
              } else if (insurance.status === "deny") {
                shouldShowClaimButton = false;
              }
            }

            if (insurance.type === "Claim Request") {
              setToggleClaimreqt(true);
            }

            if (insurance.type === "Claim Approval") {
              setToggleClaimAppove(true);
            }
          });

          setShowClaimButton(shouldShowClaimButton);
          console.log("lists:", insure);
        }
      })
    );
  };
  const getInsMaster = () => {
    dispatch(
      insuranceActions.getInsuranceMaster((resCb) => {
        if (resCb) {
          console.log("getInsuranceMaster", resCb.masterinsurancelist);

          console.log("response from api : ", resCb);
          let company = [];
          let companylist = resCb.masterinsurancelist;
          if (companylist && companylist != null) {
            for (let comp of companylist) {
              console.log("comp", comp.companyName);

              //   company.push(comp);
              //company.push(comp.id)
              companyname.push(comp);
            }
            console.log("companyname", companyname);
          }
        }
      })
    );
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    console.log("selectedOption", event.target.value);
    console.log("SELECTEDOPTION:", selectedOption);
    if (event.target.value == "") {
      setSelectedDateOption("");
    }
  };

  const handleChangeType = (event) => {
    setSelectedType(event.target.value);
    console.log("EVnn", event.target.value);
    console.log("selected", selectedType);
  };

  const insuranceButtonClick = (value, event) => {
    console.log("Event is", event);
    console.log("EVnn", value);
    setSelectedType(value);
    console.log("selected", selectedType);
    if (!event) {
      setMode("new");
    }
  };

  const insuranceEditClick = (value, event) => {
    console.log("Event is", event);
    console.log("EVnn", value);
    setSelectedType(value);
    console.log("selected", selectedType);
    if (event) {
      setMode("edit");
    }
  };

  const insuranceDeleteClick = (val, type, insurance, e) => {
    setDeleteProcedure(insurance);
    console.log("procedure conform delete:", insurance);
    console.log("conform delete:", val);
    setOpenDeleteModal(true);
    e.preventDefault();
    // markForDel(insurance)
  };

  const markForDel = () => {
    var ServerResVal = ServerRes;
    console.log("delete proceudre", deleteProcedure);
    const markForDel = {};
    markForDel["patientId"] = deleteProcedure.patientId;
    markForDel["visitId"] = deleteProcedure.visitId;
    markForDel["id"] = deleteProcedure.id;
    markForDel["markForDel"] = true;
    deleteProcedure.markForDel = true;
    console.log("presc.markForDel3", markForDel);
    dispatch(
      patientActions.markForDelInsurance(markForDel, (resCb) => {
        if (resCb) {
          console.log("deleted procedure Response ", resCb);
          if (resCb.successMessages) {
            ServerResVal.success = "Procedure details deleted successfully";
          } else {
            ServerResVal.error = "Failed to delete procedure";
          }
          handleopenDeleteModal();
          setServerRes({ ...ServerResVal });
          setShowClaimButton(false);
          getInsuranceList();
        }
        setTimeout(() => {
          closeAlert();
        }, 5000);
      })
    );
  };

  const closeModal = (event) => {
    setSelectedType(false);
    // props.onClose(event);
    getInsuranceList();
    setShowModal(false);
  };

  const closeInsuranceModal = (event) => {
    props.onClose(event);
  };

  const getFormattedDate = (date) => {
    if (date == "") return;
    const reqdate = new Date(date);
    let formatteddate = format(reqdate, "MMM dd yyyy");
    return formatteddate;
  };
  const toggleInsurance = () => {
    setviewInsurance(!viewInsurance);
  };

  const showImage = (data) => {
    console.log("showImage", data);
    console.log("insurancelist: ", insuranceLists);
    let lst = [];
    for (let index = 0; index < insuranceLists.length; index++) {
      // if (insuranceLists[index].type == "UploadDoc") {
      if (insuranceLists[index].type == "png") {
        console.log("index is : ", index, insuranceLists[index]);
        lst.push(insuranceLists[index]);
      }
    }
    setinsuranceImages(lst);
    for (let i = 0; i < lst.length; i++) {
      if (lst[i].uploadId == data) {
        console.log("element : ", lst[i].uploadId, data);
        setData(i);
      }
    }
    console.log("Images to view is : ", insuranceImages, lst, data);
    setShowModal(true);
    //setpreview(true)
  };

  const handlevisitSelect = (e) => {
    // setSelectedDate(e.target.value);
    // selectedDate = e.target.value
    console.log("handleVisitSelect", e);
    props.handlevisitChange(e);
  };

  const getFormateDate = (date) => {
    console.log("date passed:", date);
    if (date == "") return;
    const reqdate = new Date(date);
    let formatedate = format(reqdate, "MMM dd yyyy");
    return formatedate;
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };
  const handleopenDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };

  const handleChangeDate = (e) => {
    console.log("date", e.target.value);
    setSelectedDateOption(e.target.value);
  };

  return (
    <>
      <main className="">
        <Card className="p-3 my-4 mx-3">
          <div className="position-relative insurance">
            <span className="d-flex align-items-baseline justify-content-between">
              <span className="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-baseline px-0">
                <h4 className="mb-1  pl-0">Insurance&nbsp;</h4>
                <p style={{ fontSize: "12px" }}>
                  {" "}
                  ({props.patientInfo.type}, &nbsp;
                  {getFormattedDate(props.patientInfo.visitDate)})
                </p>
              </span>
              {/* <span className="mb-4 col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-end">
                <Components.VisitList
                  allVisitdates={props.allVisitdates}
                  selectedDate={props.selectedDate}
                  handlevisitChange={(e) => handlevisitSelect(e)}
                />
              </span> */}
            </span>

            {insuranceLists && insuranceLists.length > 0 ? (
              <div className="d-flex m-3 align-items-baseline filter-options">
                <div className="position-relative mx-2">
                  <i
                    title="Filter"
                    className="material-icons position-absolute text-secondary ps-5"
                    style={{
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  >
                    filter_list
                  </i>

                  <select
                    value={selectedOption}
                    name="selectType"
                    className="form-control"
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    style={{ appearance: "none" }} // Hides default dropdown arrow
                  >
                    <option value="">Select Type</option>
                    <option value="Basic">Basic</option>
                    <option value="UploadDoc">UploadDoc</option>
                    <option value="Pre Auth Request">Pre Auth Request</option>
                    <option value="Pre Auth Response">Pre Auth Response</option>
                    <option value="InvoiceGen">Invoice</option>
                    <option value="Claim Request">Claim Request</option>
                    <option value="Claim Approval">Claim Approve</option>
                    <option value="BillClear">Bill Clear</option>
                  </select>
                </div>
                <div className="mx-3">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="select date"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    onChange={handleChangeDate}
                    value={selectedDateOption}
                  />
                </div>
                {showWorkingButton && (
                  <div className="mx-2 printAction">
                    <Button
                      sx={{
                        textTransform: "capitalize",
                        marginLeft: "2px",
                        height: "33px",
                        borderRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                      id="bornon"
                      variant="contained"
                      color="primary"
                      aria-controls="print-menu"
                      aria-haspopup="true"
                      style={{
                        height: "35px",
                        borderBottomLeftRadius: "3px",
                        borderTopLeftRadius: "3px",
                      }}
                    >
                      ADD
                    </Button>

                    <Select
                      id="dr"
                      className="printAction isurancetest"
                      style={{
                        height: "35px",
                      }}
                    >
                      <MenuItem
                        className="insurance-test"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Button
                          variant="text"
                          color="primary"
                          onClick={() => insuranceButtonClick("Basic")}
                          sx={{ textTransform: "capitalize" }}
                        >
                          Add Basic Info
                        </Button>
                      </MenuItem>

                      {toggleBasic && (
                        <MenuItem onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() =>
                              insuranceButtonClick("Upload Document")
                            }
                            sx={{ textTransform: "capitalize" }}
                          >
                            Upload Document
                          </Button>
                        </MenuItem>
                      )}

                      {toggleBasic && (
                        <MenuItem onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() =>
                              insuranceButtonClick("Pre Auth Request")
                            }
                            sx={{ textTransform: "capitalize" }}
                          >
                            Pre Auth Request
                          </Button>
                        </MenuItem>
                      )}

                      {toggleBasic && (
                        <MenuItem onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() =>
                              insuranceButtonClick("Pre Auth Response", "new")
                            }
                            sx={{ textTransform: "capitalize" }}
                          >
                            Pre Auth Response
                          </Button>
                        </MenuItem>
                      )}
                      {showClaimButton && toggleBasic && togglePreauthResp && (
                        <MenuItem onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() =>
                              insuranceButtonClick("Claim Request")
                            }
                            sx={{ textTransform: "capitalize" }}
                          >
                            Claim Request
                          </Button>
                        </MenuItem>
                      )}

                      {showClaimButton && toggleBasic && togglePreauthResp && (
                        <MenuItem onClick={(e) => e.stopPropagation()}>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() =>
                              insuranceButtonClick("Claim Approval")
                            }
                            sx={{ textTransform: "capitalize" }}
                          >
                            Claim Approval
                          </Button>
                        </MenuItem>
                      )}
                    </Select>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {insuranceLists && insuranceLists.length > 0 ? (
              <div className="form-group pt-3 pb-3 mb-0">
                {insuranceLists
                  .filter((insurance) => {
                    // If NO date is selected, include ALL items
                    if (!selectedDateOption) return true;

                    // Ensure `insurance.udt` is in 'YYYY-MM-DD' format
                    const insuranceDate = new Date(insurance.udt)
                      .toISOString()
                      .split("T")[0];

                    return insuranceDate === selectedDateOption;
                  })
                  .map((insurance, index) => (
                    <>
                      <div className="d-flex flex-column px-4 insurance-section mb-3">
                        {console.log("selecteddate", selectedDate)}
                        {insurance.iName &&
                          insurance.policyNum &&
                          (selectedOption === "" ||
                            selectedOption === "Basic") && (
                            <div
                              className="d-flex align-items-end"
                              style={{
                                gap: "10px",
                                marginBottom: "16px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                className="card insurancecard"
                                style={{
                                  position: "relative",
                                  paddingBottom: "24px",
                                }}
                              >
                                {/* Edit Icon at the Top Right */}
                                {showWorkingButton && (
                                  <div className="d-flex justify-content-end">
                                    <i
                                      className="material-icons insuranceIcon mx-4"
                                      title="Edit"
                                      onClick={() =>
                                        insuranceEditClick("Basic", insurance)
                                      }
                                    >
                                      edit
                                    </i>
                                    <i
                                      className="material-icons insuranceIcon"
                                      title="Delete"
                                      onClick={(event) =>
                                        insuranceDeleteClick(
                                          true,
                                          "Basic",
                                          insurance,
                                          event
                                        )
                                      }
                                    >
                                      delete
                                    </i>
                                  </div>
                                )}

                                <div className="d-flex flex-column mt-2 mb-2 align-items-start insurance-wrap">
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    <strong>{insurance.iName}</strong> holds a
                                    policy with Policy Number{" "}
                                    <strong>{insurance.policyNum}</strong>, Card
                                    Number{" "}
                                    <strong>{insurance.cardNumber}</strong>,{" "}
                                    Expiry Date{" "}
                                    <strong>{insurance.expiryDate}</strong>.
                                  </p>
                                  {insurance.iOrg && (
                                    <p
                                      style={{
                                        margin: "4px 0",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Insurance is provided by{" "}
                                      <strong>
                                        {
                                          companyname.find(
                                            (options) =>
                                              options.id == insurance.iOrg
                                          )?.companyName
                                        }
                                      </strong>
                                    </p>
                                  )}
                                </div>
                                <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                  {getFormattedDate(insurance.udt)}
                                </span>
                              </div>
                            </div>
                          )}

                        {(insurance.uploadId && selectedOption === "") ||
                        (insurance.uploadId &&
                          selectedOption === "UploadDoc" &&
                          ["pdf", "png"].includes(insurance.type)) ? (
                          <div
                            className="d-flex align-items-end"
                            style={{ gap: "10px", marginBottom: "16px" }}
                          >
                            <div
                              className="card insurancecard"
                              style={{ position: "relative" }}
                            >
                              {/* Action Icons */}
                              {showWorkingButton && (
                                <div className="d-flex justify-content-end">
                                  {/* Show Edit only if not PDF */}
                                  {insurance.type !== "pdf" && (
                                    <i
                                      className="material-icons insuranceIcon mx-4"
                                      title="Edit"
                                      onClick={() =>
                                        showImage(insurance.uploadId)
                                      }
                                    >
                                      edit
                                    </i>
                                  )}

                                  <i
                                    className="material-icons insuranceIcon"
                                    title="Delete"
                                    onClick={(event) =>
                                      insuranceDeleteClick(
                                        true,
                                        "UploadDoc",
                                        insurance,
                                        event
                                      )
                                    }
                                  >
                                    delete
                                  </i>
                                </div>
                              )}
                              {/* Content Preview */}
                              <div className="d-flex flex-column mt-2 mb-2 align-items-start">
                                {insurance.type === "pdf" ? (
                                  <div
                                    className="pdf-card"
                                    style={{
                                      border: "1px solid #ccc",
                                      borderRadius: "8px",
                                      padding: "10px 14px",
                                      marginBottom: "10px",
                                      backgroundColor: "#f9f9f9",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        GET_UPLOAD_PATH +
                                          GET_INSURANCE_PATH +
                                          insurance.imgurl +
                                          ".pdf",
                                        "_blank"
                                      )
                                    }
                                  >
                                    <p
                                      style={{
                                        marginTop: "4px",
                                        color: "#666",
                                      }}
                                    >
                                      {insurance?.imgurl}
                                    </p>
                                  </div>
                                ) : (
                                  <img
                                    src={
                                      GET_UPLOAD_PATH +
                                      GET_UPLOAD_HOSPITAL_PATH +
                                      insurance.imgurl
                                    }
                                    className="pres-img"
                                    style={{ cursor: "pointer" }}
                                    alt="insurance"
                                  />
                                )}
                              </div>

                              {/* Timestamp */}
                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : null}

                        {(insurance.type === "Pre Auth Request" &&
                          selectedOption === "") ||
                        (insurance.type === "Pre Auth Request" &&
                          selectedOption === "Pre Auth Request") ? (
                          <div
                            className="d-flex align-items-end"
                            style={{
                              gap: "10px",
                              marginBottom: "16px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div className="card insurancecard">
                              {showWorkingButton &&
                                insuranceLists
                                  .slice(index + 1)
                                  .every(
                                    (item) =>
                                      item.type !== "Pre Auth Request" &&
                                      item.type !== "Pre Auth Response" &&
                                      item.type !== "Claim Request" &&
                                      item.type !== "Claim Approval"
                                  ) && (
                                  <div className="d-flex justify-content-end">
                                    <i
                                      className="material-icons insuranceIcon mx-4"
                                      title="Edit"
                                      onClick={(event) =>
                                        insuranceEditClick(
                                          "Pre Auth Request",
                                          insurance
                                        )
                                      }
                                    >
                                      edit
                                    </i>
                                    <i
                                      className="material-icons insuranceIcon"
                                      title="Delete"
                                      onClick={(event) =>
                                        insuranceDeleteClick(
                                          true,
                                          "Pre Auth Request",
                                          insurance,
                                          event
                                        )
                                      }
                                    >
                                      delete
                                    </i>
                                  </div>
                                )}

                              <div className="d-flex flex-column mt-2 mb-2 align-items-start insurance-wrap">
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal", // Allow text to wrap normally
                                  }}
                                >
                                  The pre-authorization request for an amount of
                                  Rs. {insurance.amount}
                                </p>
                                {insurance.description && (
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {insurance.description}
                                  </p>
                                )}
                              </div>
                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(insurance.type === "Pre Auth Response" &&
                          selectedOption === "") ||
                        (insurance.type === "Pre Auth Response" &&
                          selectedOption === "Pre Auth Response") ? (
                          <div
                            className="d-flex align-items-end"
                            style={{
                              gap: "10px",
                              marginBottom: "16px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div className="card insurancecard">
                              {showWorkingButton &&
                                insuranceLists
                                  .slice(index + 1)
                                  .every(
                                    (item) =>
                                      item.type !== "Pre Auth Request" &&
                                      item.type !== "Pre Auth Response" &&
                                      item.type !== "Claim Request" &&
                                      item.type !== "Claim Approval"
                                  ) && (
                                  <div className="d-flex justify-content-end">
                                    <i
                                      className="material-icons insuranceIcon mx-4"
                                      title="Edit"
                                      onClick={(event) =>
                                        insuranceEditClick(
                                          "Pre Auth Response",
                                          insurance
                                        )
                                      }
                                    >
                                      edit
                                    </i>
                                    <i
                                      className="material-icons insuranceIcon"
                                      title="Delete"
                                      onClick={(event) =>
                                        insuranceDeleteClick(
                                          true,
                                          "Pre Auth Response",
                                          insurance,
                                          event
                                        )
                                      }
                                    >
                                      delete
                                    </i>
                                  </div>
                                )}

                              <div className="d-flex flex-column mt-2 mb-2 align-items-start insurance-wrap">
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal", // Allow text to wrap normally
                                  }}
                                >
                                  The pre-authorization for claim number '
                                  {insurance.claimNum}' with an amount of Rs.{" "}
                                  {insurance.amount} has been{" "}
                                  {insurance.status == "approve"
                                    ? " approved"
                                    : " denied with "}
                                  {insurance.comment ? insurance.comment : ""}
                                </p>
                                {insurance.description && (
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {insurance.description}
                                  </p>
                                )}
                              </div>
                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(insurance.type === "Claim Request" &&
                          selectedOption === "") ||
                        (insurance.type === "Claim Request" &&
                          selectedOption === "Claim Request") ? (
                          <div
                            className="d-flex align-items-end"
                            style={{
                              gap: "10px",
                              marginBottom: "16px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div className="card insurancecard">
                              {showWorkingButton &&
                                !insuranceLists
                                  .slice(index + 1)
                                  .some(
                                    (item) =>
                                      item.type === "Pre Auth Request" ||
                                      item.type === "Pre Auth Response" ||
                                      item.type === "Claim Request" ||
                                      (item.type === "Claim Approval" &&
                                        item.status !== "deny")
                                  ) && (
                                  <div className="d-flex justify-content-end">
                                    <i
                                      className="material-icons insuranceIcon mx-4"
                                      title="Edit"
                                      onClick={(e) =>
                                        insuranceEditClick(
                                          "Claim Request",
                                          insurance
                                        )
                                      }
                                    >
                                      edit
                                    </i>
                                    {!insuranceLists
                                      .slice(index + 1)
                                      .some(
                                        (item) =>
                                          item.type === "Claim Approval" &&
                                          item.status === "deny"
                                      ) && (
                                      <i
                                        className="material-icons insuranceIcon"
                                        title="Delete"
                                        onClick={(e) =>
                                          insuranceDeleteClick(
                                            true,
                                            "Claim Request",
                                            insurance,
                                            e
                                          )
                                        }
                                      >
                                        delete
                                      </i>
                                    )}
                                  </div>
                                )}

                              <div className="d-flex flex-column mt-2 mb-2 align-items-start insurance-wrap">
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  The claim request for Claim Number '
                                  {insurance.claimNum}' for an amount of Rs.{" "}
                                  {insurance.amount}, associated with Invoice
                                  Number {insurance.invoiceNum}
                                </p>

                                {insurance.description && (
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {insurance.description}
                                  </p>
                                )}
                              </div>

                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(insurance.type === "Claim Approval" &&
                          selectedOption === "") ||
                        (insurance.type === "Claim Approval" &&
                          selectedOption === "Claim Approval") ? (
                          <div
                            className="d-flex align-items-end"
                            style={{
                              gap: "10px",
                              marginBottom: "16px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div className="card insurancecard">
                              <div className="d-flex justify-content-end"></div>
                              <div
                                className="d-flex flex-column mt-2 mb-2 align-items-start insurance-wrap"
                                style={{ minHeight: "30px" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  The claim for Claim Number '
                                  {insurance.claimNum}' for an amount of Rs.{" "}
                                  {insurance.amount} has been
                                  {insurance.status === "approve"
                                    ? " approved"
                                    : " denied"}
                                </p>

                                {insurance.description && (
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {insurance.description}
                                  </p>
                                )}
                              </div>

                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(insurance.type === "InvoiceGen" &&
                          selectedOption === "") ||
                        (insurance.type === "InvoiceGen" &&
                          selectedOption === "InvoiceGen") ? (
                          <div className="d-flex justify-content-between">
                            <div className="card insurancecard">
                              <div
                                className="d-flex flex-column mt-2 mb-2 align-items-start"
                                style={{ minHeight: "30px" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal", // Allow text to wrap normally
                                  }}
                                >
                                  Invoice Number {insurance.invoiceNum}{" "}
                                  generated on {insurance.invoiceDate} with
                                  amount Rs.{insurance.amount}
                                </p>
                              </div>
                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {(insurance.type === "BillClear" &&
                          selectedOption === "") ||
                        (insurance.type === "BillClear" &&
                          selectedOption === "BillClear") ? (
                          <div className="d-flex justify-content-between">
                            <div className="card insurancecard">
                              <div
                                className="d-flex flex-column mt-2 mb-2 align-items-start"
                                style={{ minHeight: "30px" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  The insurance has a type of '{insurance.type}'
                                  and marked with a status of '
                                  {insurance.status}'
                                </p>
                              </div>
                              <span className="position-absolute bottom-0 end-0 m-2 text-muted insuranceDate">
                                {getFormattedDate(insurance.udt)}
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  ))}
              </div>
            ) : (
              ""
            )}

            {viewInsurance && (
              <div className="type-fields p-3 d-flex justify-content-between">
                {!toggleBasic && !InvoiceGen && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => insuranceButtonClick("Basic")}
                    style={{ textTransform: "none" }}
                  >
                    Add Basic Info
                  </Button>
                )}
              </div>
            )}

            {showModal ? (
              <Components.PrescriptionLayoutModel
                data={data}
                uploadedImages={insuranceImages}
                onModalClose={(event) => closeModal(event)}
              />
            ) : (
              ""
            )}
            {selectedType ? (
              // <div className='modalmn'>

              <Components.InsuranceProcedureInput
                insurancetype={selectedType}
                insurancelists={insuranceLists}
                patientInfo={patientInfo}
                mode={mode}
                //patientProcedureList={patientProcedureList}
                onModalClose={(event) => closeModal(event)}
              />
            ) : (
              // </div>

              ""
            )}
          </div>
        </Card>
        <Dialog open={openDeleteModal} toggle={() => handleopenDeleteModal()}>
          <DialogTitle>Delete</DialogTitle>
          <DialogContent>
            This cannot be undone. Are you sure you want to delete?
          </DialogContent>
          <DialogActions style={{ justifyContent: `space-between` }}>
            <Button
              color="primary"
              varient="contained"
              onClick={handleopenDeleteModal}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              varient="contained"
              onClick={(event) => markForDel()}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </>
  );
}

export default InsuranceProcedureListing;
